/**
 * The store's in-app rating sheet. The stores decide whether it appears at all (iOS shows it at
 * most three times a year per app, Play meters it by quota, and neither says whether the sheet was
 * shown or what the player answered), so a request is a hint, not a promise: callers keep their
 * own pacing (apps/game/src/services/review.ts) and never promise the player a dialog.
 */
export interface ReviewProvider {
  readonly kind: 'native' | 'dev' | 'none';
  /** True when asking can reach a store (native), or is logged (dev); false on the web and Discord, where nothing is asked or counted. */
  readonly available: boolean;
  /** Ask the store to show its rating sheet. Rejects when the plugin does; resolves once the request was handed over. */
  request(): Promise<void>;
}

export class NoReviewProvider implements ReviewProvider {
  readonly kind = 'none';
  readonly available = false;
  async request(): Promise<void> {}
}
